import apiClient from './meta-client';

export interface BroadcastTemplate {
    id: number;
    user_id: number;
    title: string;
    template_params: Record<string, unknown>;
    created_at: string;
    updated_at: string;
}

export interface CreateBroadcastTemplatePayload {
    title: string;
    template_params: Record<string, unknown>;
}

export const getBroadcastTemplates = async (): Promise<BroadcastTemplate[]> => {
    const response = await apiClient.get<{ message: string; data: BroadcastTemplate[] }>(
        '/meta/broadcast-templates/'
    );
    return response.data.data;
};

export const createBroadcastTemplate = async (
    payload: CreateBroadcastTemplatePayload
): Promise<BroadcastTemplate> => {
    const response = await apiClient.post<{ message: string; data: BroadcastTemplate }>(
        '/meta/broadcast-templates/',
        payload
    );
    return response.data.data;
};

export const deleteBroadcastTemplate = async (id: number): Promise<void> => {
    await apiClient.delete(`/meta/broadcast-templates/${id}`);
};
